import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid2 as Grid, Chip } from "@mui/material";
import DeleteEarthquakeDialog from "./delete_earthquake_dialog";
import { formatteDate } from "../func/util";
import { REPORT_STATUS } from "../const/config";

const EarthquakeCard = ({ earthquake, onDeleted }) => {
  const navigate = useNavigate();

  // 日時フォーマット変換
  const formattedDate = formatteDate(earthquake.occured_at);

  // 対応状況チップの色
  const chip_color = (status) => {
    return status === "途中終了"
      ? "rgb(189,189,189)"
      : status === "完了"
        ? "rgb(72,161,75)"
        : "rgb(53,121,188)";
  };

  // ステータス判定
  const getStatusName = (earthquake) => {
    // 途中終了なら優先
    if (earthquake.report_status_uuid === REPORT_STATUS.REPORTSTOP) return "途中終了";
    // ダムと発電所の業務が完了の場合、完了
    if (earthquake.report_status_uuid === REPORT_STATUS.SECONDARYCHECK && earthquake.report_powerplant_status_uuid === REPORT_STATUS.POWERPLANTCOMPLETE) return "完了";
    // 対応中
    return "対応中";
  };

  // 詳細画面へ
  const handleEdit = () => {
    navigate(`/earthquake_detail/${earthquake.uuid}`);
  };

  return (
    <Card variant="outlined" sx={{ marginBottom: 1 }}>
      <CardContent>
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid size={{ xs: 12, sm: 5, md: 5 }}>
            <Chip
              label={`全業務：${getStatusName(earthquake)}`}
              size="small"
              sx={{
                backgroundColor: chip_color(getStatusName(earthquake)),
                color: "white",
                borderRadius: "16px",
                fontSize: "0.6rem",
                fontWeight: "bold",
                px: 1,
              }}
            />
            <Typography variant="h6" sx={{ fontWeight: "bold", mt: 0.5 }}>
              {earthquake.name}
            </Typography>
          </Grid>
          <Grid size={{ xs: 10, sm: 5, md: 5 }}>
            <Typography variant="body2">発生日時: {formattedDate}</Typography>
            <Typography variant="body2">
              最大震度: {earthquake.max_intensity}
            </Typography>
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {(earthquake.report_status_uuid !== REPORT_STATUS.REPORTSTOP && (earthquake.report_status_uuid !== REPORT_STATUS.SECONDARYCHECK || earthquake.report_powerplant_status_uuid !== REPORT_STATUS.POWERPLANTCOMPLETE)) && (
              <IconButton onClick={handleEdit}>
                <EditIcon />
              </IconButton>
            )}
            {(earthquake.report_status_uuid === REPORT_STATUS.REPORTSTOP || (earthquake.report_status_uuid === REPORT_STATUS.SECONDARYCHECK && earthquake.report_powerplant_status_uuid === REPORT_STATUS.POWERPLANTCOMPLETE)) && (
              <>
                <IconButton onClick={handleEdit}>
                  <VisibilityIcon />
                </IconButton>
                <DeleteEarthquakeDialog earthquake={earthquake}  onDeleted={onDeleted} />
              </>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EarthquakeCard;